import { ExternalLink, Instagram, Twitter, Linkedin, Github, MessageCircle, Handshake } from "lucide-react";
import { motion } from "framer-motion";
import { useState } from "react";
import { ContactModal } from "./ContactModal";

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const [isModalOpen, setIsModalOpen] = useState(false);
  
  const openContactModal = () => {
    setIsModalOpen(true);
  };
  
  return (
    <footer className="bg-gradient-to-b from-background to-accent-navy/60 pt-16 pb-8 border-t border-gray-800/50">
      <div className="max-w-7xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          {/* Logo and brief description */}
          <div className="md:col-span-5 space-y-4">
            <div className="flex items-center">
              <img src="/logo.svg" alt="Koech Creatives" className="h-8 w-auto mr-3" />
              <span className="text-xl font-semibold text-white">Koech Creatives</span>
            </div>
            <p className="text-gray-400 text-sm">
              Crafting digital experiences that inspire and connect. 
              From concept to completion, we turn your vision into reality.
            </p>
            <div className="flex space-x-4 mt-6">
              <a href="https://www.instagram.com/koech.creatives/" target="_blank" rel="noopener noreferrer" aria-label="Instagram" className="text-gray-400 hover:text-coral transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
              <a href="https://x.com/CreativesK73429" target="_blank" rel="noopener noreferrer" aria-label="Twitter" className="text-gray-400 hover:text-coral transition-colors">
                <Twitter className="w-5 h-5" />
              </a>
              <a href="https://www.linkedin.com/company/107340616" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" className="text-gray-400 hover:text-coral transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="https://github.com/Koech-Creatives" target="_blank" rel="noopener noreferrer" aria-label="Github" className="text-gray-400 hover:text-coral transition-colors">
                <Github className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Links section */}
          <div className="md:col-span-2">
            <h3 className="text-white font-medium mb-4">Services</h3>
            <ul className="space-y-2">
              <li>
                <a href="#services" className="text-gray-400 hover:text-coral text-sm transition-colors">UI/UX Design</a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-coral text-sm transition-colors">Mobile Apps</a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-coral text-sm transition-colors">Web Development</a>
              </li>
              <li>
                <a href="#services" className="text-gray-400 hover:text-coral text-sm transition-colors">Graphic Design</a>
              </li>
            </ul>
          </div>

          {/* Process section */}
          <div className="md:col-span-2">
            <h3 className="text-white font-medium mb-4">Process</h3>
            <ul className="space-y-2">
              <li>
                <a href="#process" className="text-gray-400 hover:text-coral text-sm transition-colors">Ideate</a>
              </li>
              <li>
                <a href="#process" className="text-gray-400 hover:text-coral text-sm transition-colors">Design</a>
              </li>
              <li>
                <a href="#process" className="text-gray-400 hover:text-coral text-sm transition-colors">Build</a>
              </li>
              <li>
                <a href="#" className="text-gray-400 hover:text-coral text-sm transition-colors">Our Work</a>
              </li>
            </ul>
          </div>
          
          {/* Contact section */}
          <div className="md:col-span-3">
            <h3 className="text-white font-medium mb-4">Contact</h3>
            <motion.button 
              onClick={openContactModal}
              className="flex items-center bg-coral text-white rounded-full py-2 px-4 transition-colors hover:bg-coral/90 z-10 shadow-md"
              // whileHover={{ scale: 1.03 }}
              whileTap={{ scale: 0.97 }}
            >
              <Handshake className="w-4 h-4 mr-2" />
              Let's connect 👋
            </motion.button>
          </div>
        </div>

        {/* Bottom bar with copyright */}
        <div className="mt-16 pt-8 border-t border-gray-800/50">
          <div className="flex flex-col md:flex-row justify-between items-center">
            {/* Copyright and links */}
            <div className="flex flex-col md:flex-row items-center md:items-start space-y-4 md:space-y-0">
              <p className="text-gray-400 text-sm mr-8">
                © {currentYear} Koech Creatives. All rights reserved.
              </p>
              <div className="flex space-x-6">
                <a href="#" className="text-gray-400 hover:text-coral text-sm transition-colors">Privacy Policy</a>
                <a href="#" className="text-gray-400 hover:text-coral text-sm transition-colors">Terms of Service</a>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Modal */}
      <ContactModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} />
    </footer>
  );
}; 